/**
 * UnpinIcon/index.tsx
 * desc: unpin icon (remove the current page from the sidebar) — PinIcon in its pinned state
 * note: kept as its own icon for the places that only ever unpin (the pinned rows); a toggle
 *       uses PinIcon's `pinned` prop instead so its button stays mounted
 */

import type { IconProps } from '../IconButton/typed';
import PinIcon from '../PinIcon';


const UnpinIcon = (props: IconProps) => <PinIcon pinned { ...props }/>;


export default UnpinIcon;
